import { render, staticRenderFns } from "./ViewFaqsDetail.vue?vue&type=template&id=5fcab224"
import script from "./ViewFaqsDetail.vue?vue&type=script&lang=js"
export * from "./ViewFaqsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports